import React, { useState, useEffect, useMemo } from 'react'
import Widget from './components/widget'
import Chart from './components/chart'
import RadarChart from './components/radarChart'
import Dashboard_setting from './components/dashboard_setting'
import { useGetListCompany, useGetListItems, createShareLink } from '../services/useEsgApi'
import { useDempStore } from 'src/context/stores';
import { Link, useLocation, useParams } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import { Text } from "src/components/ui/Text";
import { BaseButton } from "src/components/ui/baseButton";
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import { Loading } from 'src/components/easy-setup/modules/components/loading'
import { WEB_URL } from "src/shared/config";
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const getSubOptions = (esgType) => {
  switch(esgType) {
      case 'Environment':
          return [
              { value: 'E1', label: 'หมวดการจัดการสิ่งแวดล้อม' },
              { value: 'E2', label: 'หมวดการใช้ทรัพยากรอย่างมีประสิทธิภาพ' },
              { value: 'E3', label: 'หมวดการจัดการด้านสภาพภูมิอากาศ' }
          ];
      case 'Social':
          return [
              { value: 'S1', label: 'หมวดการเคารพสิทธิมนุษยชนและการปฎิบัติต่อแรงงานอย่างเป็นธรรม' },
              { value: 'S2', label: 'หมวดการพัฒนาศักยภาพแก่พนักงาน' },
              { value: 'S3', label: 'หมวดการจูงใจและรักษาพนักงาน' },
              { value: 'S4', label: 'หมวดสุขภาวะและความปลอดภัยในสภาพแวดล้อมการทำงาน' },
              { value: 'S5', label: 'หมวดการมีส่วนร่วมกับชุมชนและสังคม' },
              { value: 'S6', label: 'หมวดการมีส่วนร่วมของผู้มีส่วนได้เสีย' }
          ];
      case 'Governance & Economic':
          return [
              { value: 'G1', label: 'หมวดบรรษัทภิบาล' },
              { value: 'G2', label: 'หมวดจรรยาบรรณธุรกิจ ( Code of Conduct ) และการต่อต้านการทุจริต' },
              { value: 'G3', label: 'หมวดการระบุประเด็นที่เป็นสาระสำคัญของธุรกิจ ( Materiality )' },
              { value: 'G4', label: 'หมวดการบริหารความเสี่ยงและภาวะวิกฤต' },
              { value: 'G5', label: 'หมวดการบริหารจัดการความสัมพันธ์กับลูกค้า' },
              { value: 'G6', label: 'หมวดการบริหารจัดการห่วงโซ่อุปทาน' },
              { value: 'G7', label: 'หมวดการดำเนินการด้านภาษี' },
              { value: 'G8', label: 'หมวดนวัตกรรมทางธุรกิจเพื่อสังคมและ/หรือสิ่งแวดล้อม' },
              { value: 'G9', label: 'หมวดความปลอดภัยของข้อมูลและระบบสนเทศ' },
              { value: 'G10', label: 'หมวดการบริหารคุณภาพการให้บริการ' }
          ];
      default:
          return [];
  }
};

function useWindowSize() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  useEffect(() => {
    const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return size;
}


function Esg() {
  const { key,companyId: shareLinkCompanyId } = useParams();
  const {pathname} = useLocation();
  const isViewPage = pathname.includes('/view')  // console.log(key)
  const companyId = useDempStore((state) => state.companyId);
  const { listCompany, isLoadingListCompany } = useGetListCompany(companyId || shareLinkCompanyId, key);
  const [selectedYear, setSelectedYear] = useState([]);
  const [compareYear, setCompareYear] = useState(null);
  const { listItems: currentYearListItems, isLoadingListItems: isLoadingCurrentYear } = useGetListItems(companyId || shareLinkCompanyId, selectedYear, key);
  const [esgData, setEsgData] = useState([]);
  const [operationsData, setOperationsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableYears, setAvailableYears] = useState([]);
  const [compareEsgData, setCompareEsgData] = useState([]);
  const [isComparing, setIsComparing] = useState(false);
  const [visibleWidgetIds, setVisibleWidgetIds] = useState(() => {
    const savedIds = localStorage.getItem('esgVisibleWidgetIds');
    return savedIds ? JSON.parse(savedIds) : [];
  });
  const [editOpen, setEditOpen] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [shareLink, setShareLink] = useState(null);
  const [widgetData, setWidgetData] = useState();
  const [isDraggable, setIsDraggable] = useState(false);
  const [savedLayout, setSavedLayout] = useState(() => {
    const saved = localStorage.getItem('esgWidgetLayout');
    return saved ? JSON.parse(saved) : null;
  });

  const [showConfirmation, setShowConfirmation] = useState(false);

  const { width, height } = useWindowSize();

  const cols = useMemo(() => {
    if (width >= 1280) return 2;
    if (width >= 1024) return 1;
    return 1;
  }, [width]);

  const generatedLayout = useMemo(() => {
    return visibleWidgetIds.map((id, index) => ({
      i: id.toString(),
      x: index % cols,              
      y: Math.floor(index / cols),   
      w: 1,
      h: 1,
    }));
  }, [visibleWidgetIds, cols]);
  
   useEffect(() => {
    setSavedLayout(null);
  }, [visibleWidgetIds, cols]);



  const { control, handleSubmit } = useForm({
          defaultValues: {
              expiration_date: '',
              description: ''
          },
          mode: 'onChange'
      });

  useEffect(() => {
    try {
      if (listCompany && listCompany.years && Array.isArray(listCompany.years)) {
        const years = listCompany.years;
        setAvailableYears(years);
        
        if (years.length > 0) {
          const mostRecentYear = years.sort().reverse()[0];
          setSelectedYear(mostRecentYear);
        }
      }
    } catch (error) {
      console.error('Error processing company data:', error);
    }
  }, [listCompany]);

  useEffect(() => {
    if (currentYearListItems && selectedYear) {
      const yearString = String(selectedYear);
      const years = yearString.split(',');
      const currentYear = years[0];
      const compareYear = years[1];

      if (currentYearListItems?.data?.[currentYear]) {
        processEsgDataForYear(currentYearListItems, currentYear, setEsgData);
        setOperationsData(currentYearListItems.data[currentYear].operations);
      }


      if (compareYear && currentYearListItems?.data?.[compareYear]) {
        processEsgDataForYear(currentYearListItems, compareYear, setCompareEsgData);
        setIsComparing(true);
      } else {
        setCompareEsgData([]);
        setIsComparing(false);
      }
    }
  }, [currentYearListItems, selectedYear]);

  useEffect(() => {
    if (esgData.length > 0 && visibleWidgetIds.length === 0) {
      setVisibleWidgetIds(esgData.map(item => item.id));
    }
  }, [esgData]);

  const processEsgDataForYear = (data, year, setData) => {
    try {
      if (!data || !data?.data || !data?.data[year]) {
        throw new Error(`No data available for year ${year}`);
      }
      
      const yearData = data?.data[year]?.items;
      
      if (!Array.isArray(yearData)) {
        throw new Error(`Invalid data format for year ${year}`);
      }
      
      const transformedData = [];
      let idCounter = 1;
      
      yearData.forEach(item => {
        if (!item?.esgType) return;
  
        let color = "#0085FF"; // blue 
        if (item?.esgType === "Environment") {
          color = "#1FA37C"; // Green
        } else if (item?.esgType === "Social") {
          color = "#FFA800"; // Orange
        }
        
        const displayName = item?.esgType;
        
        const tags = [];
        
        if (item?.score) {
          tags?.push(`Score: ${item?.score}`);
        }
        
        if (item?.sdGoal && Array.isArray(item?.sdGoal)) {
          tags?.push(`SDGs: ${item?.sdGoal?.join(', ')}`);
        }
        
        if (item?.griStandard && Array.isArray(item?.griStandard)) {
          tags?.push(`GRI: ${item?.griStandard?.join(', ')}`);
        }
        
        if (item?.suggestion) {
          tags?.push(`${item?.suggestion}`);
        }
        
        if (tags?.length === 0) {
          tags?.push(item?.esgType);
        }
        
        let images = [];
        
        if (item?.sdGoal && Array.isArray(item?.sdGoal)) {
          images = item?.sdGoal.map(sdg => String(sdg));
        }
        
        transformedData.push({
          id: idCounter++,
          name: displayName,
          description: item?.esgType + (item?.subType ? ` - ${item?.subType}` : ''),
          image: images,
          color: color,
          item: tags,
          rawData: item
        });
      });
      
      setData(transformedData?.length > 0 ? transformedData : []);
      setLoading(false);
    } catch (error) {
      console.error(`Error processing ESG data for year ${year}:`, error);
      setData([]);
      setLoading(false);
    }
  };

  

  const handleYearChange = (year) => {
    setSelectedYear(year);
    setCompareYear(null);
    setCompareEsgData([]);
    setIsComparing(false);
    setLoading(true);
  };

  const handleCompareYears = (currentYear, previousYear) => {
    const years = [String(currentYear), String(previousYear)].join(",");
    setSelectedYear(years);
    setCompareYear(previousYear);
    setIsComparing(true);
    setLoading(true);
  };


  const submitForm = async (data) => {
    const formData = {
      ...data,
      feature: "ESG",
      expiration_date: new Date(data.expiration_date),
      company: companyId,
    }

    const todays_date = new Date()
    
    if(formData.expiration_date < todays_date) {
      alert("Expiration date cannot be in the past")
      return
    }

    if(!companyId || !data.expiration_date) {
      alert("Please select expiration date")
      return
    }
    // if(formData.expiration_date.getYear() > todays_date.getYear()){
    //   alert("Expiration date cannot be more than 1 year")
    // } TODO: handle this later with better validation


    try {
      setIsSubmitting(true);
      const response = await createShareLink(formData);
  
      if (response?.data?.data?.token) {
        const token = response?.data?.data?.token;
        //TODO: check the env variable for the url
        const cleanWebUrl = WEB_URL.replace(/\/$/, ''); // Remove trailing slash if it exists
        setShareLink(`${cleanWebUrl}/esg/${companyId}/view/${token}`);

      }
      //TODO: need better error handling
    } catch (error) {
      console.error('Error creating share link:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopyLink = () => {
    if (shareLink) {
      navigator.clipboard.writeText(shareLink.replace("//esg", "/esg"));
    }
  };

  

  return (
    <div className='h-full p-2 md:p-4 lg:p-6'>
      <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4'>
        <div className='flex items-center gap-2 w-full sm:w-auto'>
          <Dashboard_setting 
            years={availableYears}
            onYearChange={handleCompareYears}
          />

          {!isViewPage && (
          <button onClick={() => setIsDraggable(true)}>
            <i className="ri-settings-3-line text-2xl md:text-3xl text-vekin"></i>
          </button>
          )}
        </div>

        {!isViewPage && <div className='flex justify-end gap-2 w-full sm:w-auto'>
          <button onClick={() => setShowShare(true)} className="p-2 text-center border rounded-lg border-vekin text-vekin whitespace-nowrap">
            <i className="pr-2 ri-share-forward-fill"></i>Share</button>
        </div>}
      </div>

      {(!isViewPage && showShare) && (
        <Dialog open={showShare} onClose={() => {
          setShowShare(false);
          setShareLink(null);
          setIsSubmitting(false);
        }} maxWidth="sm" fullWidth>
          <div className='p-4'>
            <div className="flex flex-col gap-1 pb-2 border-b border-quartenary">
                <Text variant={"semi-22"} className={"text-vekin"}>
                  Share Dashboard
                </Text>
                <Text variant={"medium-12"} className={"text-primary"}>
                  To create a shareable link, please specify the duration and description of the link.
                </Text>
            </div>

            {isSubmitting ? (
              <div className="flex items-center justify-center p-8">
                <Loading />
              </div>
            ) : shareLink ? (
              <div className="flex flex-col sm:flex-row items-center gap-2 p-4">
                <div className="p-3 text-xs py-2 break-all border rounded-lg bg-gray-50 w-full">
                  {shareLink}
                </div>
                <button
                  onClick={handleCopyLink}
                  className="px-2 py-2 text-xs bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] text-white rounded-lg hover:opacity-90 transition-all font-medium whitespace-nowrap"
                >
                  Copy Link
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit(submitForm)} id="itemForm" className='p-4'>
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-600">Link Expiration Date</label>
                  <Controller
                    name={"expiration_date"}
                    control={control}
                    render={({ field }) => (
                      <input {...field} type="date" className="w-full p-3 border rounded-lg" placeholder="Enter Description..." />
                    )}
                  />
               </div>
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-600">Link Description</label>
                  <Controller
                    name={"description"}
                    control={control}
                    render={({ field }) => (
                      <textarea {...field} type="text" className="w-full p-3 border rounded-lg" placeholder="Enter Description..." />
                    )}
                  />
               </div>
              </form>
            )}

            <div className="flex flex-col sm:flex-row justify-end gap-4">
              <button
                variant="secondary"
                size="normal"
                className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-700 text-white rounded-lg hover:opacity-90 transition-all font-medium w-full sm:w-auto"
                onClick={() => {
                  setShowShare(false);
                  setShareLink(null);
                  setIsSubmitting(false);
                }}
              >
                {shareLink ? 'Close' : 'Cancel'}
              </button>

              {!shareLink && !isSubmitting && (
                <button
                  type="submit"
                  form="itemForm"
                  className="px-6 py-2.5 bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] text-white rounded-lg hover:opacity-90 transition-all font-medium w-full sm:w-auto"
                >
                  Create Link
                </button>
              )}
            </div>
          </div>
        </Dialog>
      )}
      
      {availableYears.length > 0 && (
        <div className='flex flex-wrap gap-2 mb-4'>
          {availableYears?.map(year => (
            <button
              key={year}
              className={`px-4 py-2 rounded-md ${selectedYear === year 
                ? 'bg-vekin text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'}`}
              onClick={() => handleYearChange(year)}
            >
              {year}
            </button>
          ))}
        </div>
      )}

      <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="xs" fullWidth>
        <div className="p-4 md:p-6">
          <h2 className="mb-4 text-lg font-semibold">Select Widgets to display</h2>
          <div className="flex flex-col gap-2 mb-4">
            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    color: "#047857",
                    '&.Mui-checked': {
                      color: "#047857",
                    },
                  }}
                  checked={visibleWidgetIds.length === esgData.length}
                  indeterminate={visibleWidgetIds.length > 0 && visibleWidgetIds.length < esgData.length}
                  onChange={(e) => {
                    const newVisibleWidgetIds = e.target.checked ? esgData.map(item => item.id) : [];
                    setVisibleWidgetIds(newVisibleWidgetIds);
                    localStorage.setItem('esgVisibleWidgetIds', JSON.stringify(newVisibleWidgetIds));
                  }}
                />
              }
              label="Select All"
            />
            <div className="my-2 border-t border-gray-200"></div>
            <div className="max-h-[60vh] overflow-y-auto">
              {esgData
                .sort((a, b) => {
                  const order = {
                    'Environment': 1,
                    'Social': 2,
                    'Governance & Economic': 3
                  };
                  return (order[a.rawData?.esgType] || 999) - (order[b.rawData?.esgType] || 999);
                })
                .map(item => (
                <FormControlLabel
                  key={item.id}
                  control={
                    <Checkbox
                      sx={{
                        color: "#047857",
                        '&.Mui-checked': {
                          color: "#047857",
                        },
                      }}
                      checked={visibleWidgetIds.includes(item.id)}
                      onChange={e => {
                        let newVisibleWidgetIds;
                        if (e.target.checked) {
                          newVisibleWidgetIds = [...visibleWidgetIds, item.id];
                        } else {
                          newVisibleWidgetIds = visibleWidgetIds.filter(id => id !== item.id);
                        }
                        setVisibleWidgetIds(newVisibleWidgetIds);
                        localStorage.setItem('esgVisibleWidgetIds', JSON.stringify(newVisibleWidgetIds));
                      }}
                    />
                  }
                  label={(() => {
                    const options = getSubOptions(item.rawData?.esgType);
                    const found = options.find(opt => opt.value === item.rawData?.subType);
                    return found ? found.label : item.name + (item.rawData?.subType ? ` (${item.rawData?.subType})` : '');
                  })()}
                />
              ))}
            </div>
          </div>
          <div className="flex justify-center gap-2">
            <button onClick={() => setEditOpen(false)} className="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-600/80">Cancel</button>
            <button onClick={() => {
              localStorage.setItem('esgVisibleWidgetIds', JSON.stringify(visibleWidgetIds));
              setEditOpen(false);
            }} className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white px-4 py-2">Submit</button>
          </div>
        </div>
      </Dialog>

      {esgData?.length > 0 ? (
        <div className='grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-5 3xl:grid-cols-2 gap-4'>
          <div className='2xl:col-span-2 3xl:col-span-1'>
            <div className='p-4 bg-white shadow-sm rounded-xl'>
              <Chart dataEsg={esgData} compareData={compareEsgData} compareYear={compareYear} currentYear={selectedYear} />
            </div>
            <div className='mt-4'>
              <RadarChart dataEsg={operationsData} />
            </div>
          </div>
            <div className={`h-[1550px] overflow-y-auto scrollbar-hide 2xl:col-span-3 3xl:col-span-1`}>
              {loading || isLoadingCurrentYear ? (
                <div>Loading ESG data...</div>
              ) : (
                <>
                  {isDraggable &&(
                    <div className="flex justify-between gap-2 mb-4">
                      <button onClick={() => setEditOpen(true)}>
                        <i className="ri-list-settings-fill text-2xl"></i>
                      </button>
                      <div className="flex items-center gap-2">
                        <button onClick={() => setShowConfirmation(true)} className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white p-2 px-4">save</button>
                        <button onClick={() => setIsDraggable(false)} 
                        // className="p-2 px-4 text-red-400 border-2 rounded-lg border-black-200 hover:border-red-400/80"
                        >
                          <i className="ri-close-fill text-4xl"></i>
                        </button>
                      </div>
                    </div>
                  )}
                  <GridLayout
                    className="h-full overflow-y-auto overflow-x-hidden layout rounded-xl"
                    width={
                      window.innerWidth >= 1280 ? 800 : 
                      window.innerWidth >= 1024 ? 700 : 
                      window.innerWidth >= 768 ? 600 :  
                      window.innerWidth >= 640 ? 400 :   
                      window.innerWidth - 32
                    } 
                    cols={
                      window.innerWidth >= 1024 ? 2 : 1 
                    }
                    rowHeight={window.innerHeight * (window.innerWidth >= 1024 ? 32 : 40) / 100} 
                    height={1600}
                    margin={[16, 16]}
                    isResizable={false}
                    isDraggable={isDraggable}
                    compactType='vertical'
                    layout={savedLayout || generatedLayout}
                    onLayoutChange={(layout) => {
                      localStorage.setItem('esgWidgetLayout', JSON.stringify(layout));
                      setSavedLayout(layout);
                    }}
                  >
                    {visibleWidgetIds.map(id => {
                      const item = esgData.find(i => i?.id === id);
                      const match = isComparing ? compareEsgData?.find(
                        c => c.rawData?.esgType === item?.rawData?.esgType && c.rawData?.subType === item?.rawData?.subType
                      ) : null;
                      return (
                        <div key={item?.id} className={`relative h-full ${isDraggable ? 'cursor-move' : ''}`}>
                          <Widget data={item} year={selectedYear} compareData={match} compareYear={compareYear} dragAble={isDraggable} />
                        </div>
                      );
                    })}
                  </GridLayout>
                </>
              )}
            </div>
          
        </div>
      ) : (
        <div className='flex items-center justify-center h-full'> 
          {!isViewPage ? <div className='flex flex-col items-center justify-center p-4 text-center'>
            <p className="mb-4 text-lg">Let's get started — add your data to build your first dashboard!</p>
            <Link to={`/data-source-mng`} className="flex items-center gap-1 px-6 py-3 text-sm font-semibold text-white rounded-lg bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] hover:opacity-90 transition-opacity">
              Add Data Source
            </Link>
          </div>:
          <div className='flex flex-col items-center justify-center p-4 text-center'>
            <p className="mb-4 text-lg">404 Page Not Found</p>
          </div>

          }
        </div>
      )}

      {showConfirmation && (
        <Dialog open={showConfirmation} onClose={() => setShowConfirmation(false)} maxWidth="sm" fullWidth>
          <div className="p-4 md:p-6">
            <p className="py-2 text-lg font-semibold text-primary">Save Confirmation</p>
            <p className="py-2 text-sm text-center">Do you want to save your changes?</p>
            <div className="flex justify-center gap-8 pt-4">
              <button onClick={() => {
                setIsDraggable(false)
                setShowConfirmation(false)
              }} className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white px-6 py-2">
                Save
              </button>
              <button onClick={() => setShowConfirmation(false)} className="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-600/80">
                Cancel
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  )
}

export default Esg

